import {
  AfterViewInit,
  ApplicationRef,
  ChangeDetectorRef,
  Component,
  ComponentFactoryResolver,
  ElementRef,
  EventEmitter,
  forwardRef,
  HostBinding,
  HostListener,
  Injector,
  Input,
  OnDestroy,
  OnInit,
  Output,
  Renderer2,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import {
  AbstractControl,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR
} from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import {
  debounceTime,
  switchMap,
  takeWhile,
  catchError
} from 'rxjs/operators';
import {
  Subject,
  of
} from 'rxjs';

import { DropdownListComponent } from './dropdownList.component';
import { DropdownMenuComponent } from './dropdown-menu.component';

@Component({
  selector: 'axis-dropdown,[axis-dropdown]',
  templateUrl: './dropdown.component.html',
  host: {
    class: 'axis-dropdown',
    '[attr.iscombobox]': 'isCombobox',
    '[class.axis-combobox]': 'isCombobox',
    '[class.axis-combobox-focus]': '(isComboboxFocus && comboBoxContent?.length > 0)'
  },
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DropdownComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => DropdownComponent),
      multi: true
    }
  ]
})
export class DropdownComponent implements OnInit, AfterViewInit, OnDestroy {

  alive = true;
  ariaLabelDefault = 'Please select'; // screen readable (no '...')
  isClosed = true;
  typeaheadApiCallUrlEvent = new Subject<string>();
  typeaheadApiCallFunctionEvent = new Subject<string>();
  keyClear;
  keysSoFar = '';
  keysCombobox: Array<string> = [
    'arrowdown',
    'arrowup',
    'down',
    'end',
    'esc',
    'escape',
    'home',
    'up',
    'enter',
    'tab',
  ];
  keysFilter: Array<string> = this.keysCombobox;
  keysMultiSearchSelect: Array<string> = this.keysCombobox;
  keysTypeahead: Array<string> = this.keysCombobox;
  placeholderDefault = 'Please select...';
  placeholderMultiSearchSelect: string;
  typedText = '';

  public active = false;
  public labelId = '';
  public appendSelectedClass = true;
  public arrowKey = false;
  public columns;
  public comboBoxContent = '';
  public componentRef: any;
  public customTitle = '';
  public _dataProvider: Array<Object> = [];
  public dataProviderCopy: Array<any>;
  public dpLength = 0;
  public dropdownListArray = new Array<DropdownListComponent>();
  public elementIndex = 0;
  public hasWidthChanged = false;
  public _heading = 'Please select...';
  public isCleared = false;
  public isComboboxFocus = false;
  public isDataproviderChanged = false;
  public isListItem = false;
  public isMoreResults = false;
  public isNoResults = false;
  public isObjectEnabled = false;
  public isTouchedOutside = false;
  public left: any;
  public menuMinWidthCheck;
  public model: any = '';
  public multiSearchText: any = '';
  public right: any;
  public searchFilterText = '';
  public selectAllChecked = false;
  public selectedItems = new Array();
  public target: any;
  public top: any;
  public typeaheadContent = '';
  public selectedListId;
  public ucid = '';
  private axisIncComponentRef: any;
  private containerEl = document.querySelector('body');
  public  isClicked = false;
  public renderingIcon ='';
  private isSearchTextEventEmitted = false;
  private previousText = '';
  private scrollYPosition: any;
  private unbindDocumentEvent: Function;
  private unbindMouseOverEvent: Function;
  private unbindKeyEvent: Function;
  private unbindScrollEvent: Function;
  private unbindResizeEvent: Function;

  @HostBinding('class.open') public isOpen = false;

  @Input() actionLabel = 'Action';
  @Input() dataShared = false;
  // @Input('data-align') align: string = 'left';
  @Input() apiCall: any;
  @Input('aria-label') ariaLabel: string;
  // tslint:disable-next-line: no-input-rename
  @Input('aria-label-action') ariaLabelAction: string;
  @Input('aria-labelledby') ariaLabelledby: string;
  @Input() axisIncludeComponent: any;
  // @Input() axisInclude: string;
  @Input() clearOnFocusOut: any = true;
  @Input() clientSideValidation = true;
  @Input() closeOnOutsideClick = true;
  @Input() columnCount = 1;
  @Input() context: any;
  @Input() disabled = false;
  @Input() filterStartsWith = false;
  @Input() font = 'material';
  @Input() icon = '';
  @Input() isActionMenu = false;
  @Input() isCombobox = false;
  @Input() isImage = false;
  @Input() isInsideModal = false;
  @Input() isLabelVisible = false;
  @Input() isIconOnly = false;
  @Input() isMultiSearchSelect = false;
  @Input() isNestedMultiselect = false;
  @Input() isPageContentSearch = false;
  @Input() isReadOnly: boolean;
  @Input() isSelectAll = false;
  @Input() isTypeahead = false;
  // tslint:disable-next-line: no-input-rename
  @Input('data-kind') kind = 'button'; // To apply css in ng9, input name should be data-kind.
  @Input() maxItemsLength = 3;
  @Input() maxVisibleRows = 3;
  @Input() menuMaxHeight: number;
  @Input() menuMaxWidth: number;
  @Input() menuMinWidth: number;
  @Input() messageNoResults = 'No results found';
  @Input() moreResultsMessage: any;
  @Input() noOfSearchResults = 10;
  @Input() noOfSearchResultsList: number;
  @Input() placeholder = 'Please select...';
  @Input() readonlyHeaders = false;
  @Input() regExp: RegExp;
  @Input() rel: string;
  @Input() renderingImageLabel = '';
  @Input() renderingLabel = 'name';
  @Input() retrieveFieldName = ''; // provide property name whose value you want in return as a string on selection
  @Input() required = false;
  @Input() searchProperties: any;
  @Input() selectedIndex = -1;
  @Input() showSelected = true;
  @Input() size = 'medium';
  @Input() templateClasses: any;
  @Input() triggerLength = 3;
  @Input() type = 'select';
  @Input() width: number;
  @Input() wrap = false;
  @Input() maxSelectionCount: number;
  @Input() buttonKind: string;

  @Input()
  set heading(x) {
    this._heading = x;
    this.resetCustomTitle();
  }
  get heading() {
    return this._heading;
  }

  @Input()
  set dataProvider(val: Array<Object>) {
    if (val && val.length > 0) {
      if (this._dataProvider.length !== val.length) {
        this.isDataproviderChanged = true;
      }
      if (this.isTypeahead && this.typedText && this.typedText.length >= this.triggerLength) {
        this.isOpen = true;
      }
      this.dpLength = val.length;
      this._dataProvider = val;
      if (!this.isCombobox && !this.isTypeahead) {
        this.dataProviderCopy = Array.from(val);
      }
    } else {
      if (this.isTypeahead && this.typedText && this.typedText.length >= this.triggerLength) {
        this.isOpen = true;
      }
      if (this.componentRef && this._dataProvider.length > 0) {
        this.isDataproviderChanged = true;
      }
      this._dataProvider = [];
      this.dataProviderCopy = [];
    }
    this.isObjectEnabled = true;
    // Reset model on change of dataprovider
    if (!this.isOpen && this.model && !this.typedText) {
      this.model = null;
      this.resetSelection();
    } else if (this.isTypeahead && this.isOpen && this.typedText && this.typedText.length >= this.triggerLength) {
      this.isSearchTextEventEmitted = true;
      this.typeaheadSearch(this.typedText); //  to update list of typeahead with typedtext
    } else if (this.isCombobox && this.isOpen && this.typedText) {
      this.isSearchTextEventEmitted = true;
      this.searchFilter(this.typedText); //  to update list of combobox with typedtext
    }
    // Emits event everytime on change of dataprovider(To load model value on change of dataprovider)
    this.onDataproviderChange.emit();
    if (!this.changeDetectorRef['destroyed']) {
      this.changeDetectorRef.detectChanges();
    }
  }
  get dataProvider() {
    return this._dataProvider;
  }

  @Output() actionEvent = new EventEmitter();
  @Output() onDataproviderChange = new EventEmitter();
  @Output() onDataproviderSubscription = new EventEmitter();
  @Output() onSearchText = new EventEmitter();
  @Output() onSelect = new EventEmitter();
  @Output() onTouchedEmitter = new EventEmitter();
  @Output() openClose = new EventEmitter();
  @Output() onMultiSelect = new EventEmitter();

  @ViewChild('axisInclude', { read: ElementRef, static: true }) axisIncludeRef: ElementRef;
  @ViewChild('btnWidth', { static: true }) btnWidth: ElementRef;
  @ViewChild('container', { read: ViewContainerRef, static: true }) container: ViewContainerRef;
  @ViewChild('container', { static: true }) inpCompContainer: ElementRef;
  @ViewChild('inputArea') inputArea: ElementRef;
  @ViewChild('list', { static: true }) list: ElementRef;
  @ViewChild('menu', { read: ElementRef, static: true }) dropdownMenu: ElementRef;
  @ViewChild('multiSearchSelect', { read: ElementRef }) multiSearchSelect: ElementRef;
  @ViewChild('searchIcon', {static: false}) searchIcon: any;

  private propagateModelChange = (_: any) => { };
  private onTouched: any = (_: any) => { };

  constructor(
    private applicationRef: ApplicationRef,
    private changeDetectorRef: ChangeDetectorRef,
    public elRef: ElementRef,
    private httpClient: HttpClient,
    private injector: Injector,
    private renderer2: Renderer2,
    private resolver: ComponentFactoryResolver) { }

  ngOnInit() {
    this.ucid = (Math.random() + Math.random()).toString().replace('.', ''); // create unique id for select all in checkbox
    // set isClosed to false, since page content search dropdown is always open and should be open on load.
    if (this.isPageContentSearch) {
      this.isClosed = false;
    }
    if (!this.ariaLabelledby) { // use ariaLabelledby first (points to id of existing label)
      if (this.isCombobox || this.isTypeahead) {
        this.ariaLabelDefault = this.placeholder; // set the combobox/typeahead placeholder.
      }
      if (!this.ariaLabel) {
        this.ariaLabel = this.ariaLabelDefault; // if no value, use the default for dd (not inputs)
      } else {
        this.ariaLabelDefault = this.ariaLabel; // if assigned a value, make that value the default
      }
    } else {
      if (this.isCombobox || this.isTypeahead) {
        this.ariaLabelDefault = ''; // clear default for inputs
      }
    }

    if (!this.ariaLabelAction) {
      this.ariaLabelAction = this.actionLabel;
    }

    if (this.type === 'Radio') {
      this.type = this.type.toLocaleLowerCase();
    }

    if (!this.placeholder) {
      this.placeholder = this.placeholderDefault; // if no value, use the default for dd (not inputs)
    } else {
      this.placeholderDefault = this.placeholder; // if assigned a value, make that value the default
    }
    this.placeholderMultiSearchSelect = this.placeholder;

    if (!this.moreResultsMessage) {
      this.moreResultsMessage = 'Too many results...';
    }
    if (!this.dataProvider) {
      this.isObjectEnabled = false;
    }
    this.resetCustomTitle();

    if ((this.kind === 'icon' && this.icon !== '') || !this.showSelected) {
      this.appendSelectedClass = false;
    }
    this.menuMinWidthCheck = this.menuMinWidth;
    this.typeaheadApiCallUrlSubscription();
    this.typeaheadApiCallFunctionSubscription();
  }

  ngAfterViewInit() {
    if (!this.changeDetectorRef['destroyed']) {
      this.changeDetectorRef.detectChanges();
    }
    if (this.elRef.nativeElement.attributes['data-col']) {
      this.columns = this.elRef.nativeElement.attributes['data-col'].value;
    }
    this.addComboboxClickEvent();
    // Below code is added for floating label only
    if (this.isCombobox || this.isTypeahead) {
      this.renderer2.addClass(this.elRef.nativeElement.parentElement, 'axis-form-control-filled');
    }
    if(this.retrieveFieldName) {
      this.isClicked = true;
      this.changeDetectorRef.detectChanges();
    }
    if (this.isCombobox) {
       this.renderer2.setAttribute(this.elRef.nativeElement,'role','combobox');
       this.renderer2.setAttribute(this.elRef.nativeElement,'aria-haspopup','listbox');
       this.renderer2.setAttribute(this.elRef.nativeElement,'aria-expanded','false');
    }
  }


  // To show multi column dropdown on hover
  @HostListener('mouseover')
  mouseover() {
    if (this.elRef.nativeElement.attributes['data-col']) {
      this.isOpen = true;
      this.active = true;
      this.displayDropdown();
    }
  }

  // On window resize, dropdown menu is emitting the resizeEvent
  // @HostListener('window:resize', [])
  onResize(): void {
    this.hasWidthChanged = true;
    if (!this.menuMinWidthCheck) {
      this.setMinWidth();
    }
    if ((this.kind === 'button' || this.kind === 'link')
      && !this.renderingImageLabel && !this.columns && !this.isNestedMultiselect && !this.menuMinWidthCheck && this.wrap) {
      this.setMaxWidth();
    }
  }

  setMinWidth() {
    // Sets min width to dropdown list if there is no minwidth specified for dropdown list.
    if (this.width) {
      this.menuMinWidth = this.width;
    } else if (!this.menuMinWidth || this.hasWidthChanged && !this.width) {
      this.menuMinWidth = this.elRef.nativeElement.offsetWidth; // axis-dropdown width
    }
  }

  setMaxWidth() {
    // Sets max width to dropdown list if there is no maxwidth specified for dropdown list.
    if (this.width) {
      this.menuMaxWidth = this.width;
    } else if (!this.menuMaxWidth || this.hasWidthChanged && !this.width) {
      this.menuMaxWidth = this.elRef.nativeElement.offsetWidth; // axis-dropdown width
    }
  }

  /**
   * API method to load model value on dataprovider change.
   * @param dataprovider as Array
   * @param model as any - new modal value for pre selection.
   */
  setModelonDataproviderChange(dataprovider, model) {
    this.dataProvider = dataprovider;
    this.model = model;
    this.preDefinedSelection(this.model);
    this.propagateModelChange(this.model);
  }

  // Implementing ControlValueAccessor for AxisDropDown
  // ::For custom form validations(triggered when assigned to ngModel)
  writeValue(value: any) {
    if (value) {
      this.model = value;
      this.preDefinedSelection(this.model);
    } else {
      this.model = null;
      this.resetSelection();
    }
  }
  registerOnChange(fn: any): void {
    this.propagateModelChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  validate(control: AbstractControl): { [key: string]: any } {
    if (this.required) {
      if (control.value) {
        if (typeof control.value === 'object') {
          return Object.keys(control.value).length > 0
            ? null
            : { axisdropdown: { valid: false } };
        } else {
          return (control.value || control.value === 0 ) ? null : { axisdropdown: { valid: false } };
        }
      }
      return { axisdropdown: { valid: false } };
    }
  }

  // ControlValueAccessor ENDS
  // Utility function to find item in selecetd items array
  isContains(item): number {
    let index = -1;
    this.selectedItems.forEach((d, idx) => {
      if (d === item) {
        index = idx;
      }
    });
    return index;
  }

  uniqueItems(item, index, self) {
    return self.indexOf(item) === index;
  }

  // Returns selected items :: multiSelect and multisearchselect
  getSelectedItems() {
    const items: any = [];
    this.selectedItems.forEach(item => {
      items.push(Object.assign({}, item));
    });
    return items;
  }

  // Clears selected list items
  emptySelectedItems() {
    if (this.selectedItems) {
      this.selectedItems.splice(0, this.selectedItems.length);
    }
  }

  isSelected(option) {
    return option.isSelected;
  }

  getModel() {
    return this.model;
  }

  // Reset model value and notifies
  resetModel() {
    this.model = null;
    this.resetSelection();
    this.propagateModelChange(this.model);
    this.onSelect.emit(this.model);
    // open combobox on clear.
    if (this.isCombobox) {
      this._openCombobox();
      this.focusComboBox();
    }
  }

  // Reset dropdown's model on focus out if filtered list is empty.
  resetOnBlur() {
    if (this.dataProvider) {
      this.dataProvider.forEach((item: DropdownListComponent) => {
        if (item['isSelected']) {
          item.isSelected = false;
        }
      });
    }
    if (this.model) {
      this.model = null;
      if (!this.isCleared) {
        this.propagateModelChange(this.model);
        this.onSelect.emit(this.model);
        this.isCleared = false;
      }
    }
  }

  // function to deselect other list items in dropdown::only for select
  deSelectOthers(comp: DropdownListComponent) {
    this.dropdownListArray.forEach((item: DropdownListComponent) => {
      if (item !== comp) {
        item.isSelected = false;
        item.option.isSelected = false;
      }
    });
  }

  resetPrevSelection() {
    this.dataProvider.forEach((item) => {
      item['isSelected'] = false;
    });
    this.dataProviderCopy = [];
  }

  // toggles selection of multi select options
  toggleSelection(checked: boolean) {
    this.dropdownListArray.forEach((item: DropdownListComponent) => {
      item.isSelected = !item.disabled ? checked : item.isSelected;
      item.option.isSelected = !item.option.disabled
        ? checked
        : item.option.isSelected;
      this.notifyChange(item);
    });
  }
// reset as api method to reset selected items
  public reset(model = null) {
    this.typeaheadContent = '';
    this.comboBoxContent = '';
    this.resetModel();
    if (model) {
      this.model = model;
      this.preDefinedSelection(model);
      this.onSelect.emit(this.model);
    }
  }

  // reset all options of dropdown
  resetSelection() {
    if (this.dropdownListArray) {
      this.dropdownListArray.forEach((item: DropdownListComponent) => {
        item.isSelected = false;
        if (item.option) {
          item.option.isSelected = false;
          if (item.option.children && item.option.children.length > 0) {
            item.option.children.forEach((child: DropdownListComponent) => {
              child.isSelected = false;
            });
          }
        }
      });
    }
    this.resetCustomTitle();
    this.emptySelectedItems();
    this.selectAllChecked = false;
    if (!this.target && !this.isCleared) {
      if (this.isTypeahead) {
        this.typeaheadContent = '';
      }
      if (this.isCombobox && this.clientSideValidation) {
        this.comboBoxContent = '';
      }
    }
    this.target = null;
    this.isCleared = false;
  }

  // Enabler or disable dropdown form element
  setDisabledState(isDisabled: boolean) {
    this.disabled = isDisabled;
  }

  disableDropdown() {
    this.disabled = true;
  }

  enableDropdown() {
    this.disabled = false;
  }

  toggleDisableDropdown() {
    this.disabled = !this.disabled;
  }

  /* Method to render selected label name  */
  renderTitle(selectedItems) {
    if (!this.showSelected) {
      this.resetCustomTitle();
      return;
    }
    if (this.isArray(selectedItems)) {
      if(this.isMultiSearchSelect) {
        this.selectedItems = selectedItems;
      }
      if (selectedItems.length <= this.maxItemsLength) {
        selectedItems.forEach((d, index: number) => {
          if (index === 0) {
            this.customTitle = d[this.renderingLabel] || d['value'] || d;
            this.ariaLabel = d['ariaLabel'] || this.customTitle;
          } else {
            this.customTitle +=
              ', ' + (d[this.renderingLabel] || d['value'] || d);
            this.ariaLabel +=
              ', ' + (d['ariaLabel'] || d[this.renderingLabel] || d['value'] || d);
          }
        });
      } else {
        this.customTitle = selectedItems.length + ' Selected';
        this.ariaLabel = this.customTitle;
      }
      if (
        this.type === 'multiSelect' && this.model && this.isSelectAll
      ) {
        this.customTitle = '';
        this.ariaLabel = '';
        let selectedListcount = 0;
        this.selectedItems = [];
        this.dataProvider.forEach((d, index: number) => {
          if (d['isSelected'] === true) {
            selectedListcount++;
            this.selectedItems.push(d);
          }
        });
        if (selectedListcount <= this.maxItemsLength) { // list count less than 3
          let selectedItem = 0;
          this.dataProvider.forEach((d, index: number) => {
            if (d['isSelected'] === true) {
              if (selectedItem === 0) {
                this.customTitle +=
                  (d[this.renderingLabel] || d['value'] || d);
                this.ariaLabel +=
                  (d['ariaLabel'] || d[this.renderingLabel] || d['value'] || d);
              } else {
                this.customTitle +=
                  ', ' + (d[this.renderingLabel] || d['value'] || d);
                this.ariaLabel +=
                  ', ' + (d['ariaLabel'] || d[this.renderingLabel] || d['value'] || d);
              }
              selectedItem++;
            }
          });
        } else { // list count greater than 3
          this.customTitle = selectedListcount + ' Selected';
          this.ariaLabel = this.customTitle;
        }
        if (selectedListcount === this.dataProvider.length) { // all items are selected
          this.customTitle = 'All Selected';
          this.ariaLabel = this.customTitle;
          this.selectAllChecked = true;
        } else if (selectedListcount === 0) { // no item is selected
          this.customTitle = this.placeholder;
          this.ariaLabel = this.customTitle;
        } else {
          this.selectAllChecked = false;
        }
      } else if (
        this.type === 'multiSelect' &&
        this.isSelectAll &&
        this.dropdownListArray &&
        this.dropdownListArray.length === selectedItems.length && !this.model
      ) {
        this.customTitle = 'All Selected';
        this.ariaLabel = this.customTitle;
      }
    } else {
      this.customTitle =
        selectedItems.option[this.renderingLabel] ||
        selectedItems.option['value'] ||
        selectedItems.option['label'];
        this.renderingIcon =  selectedItems.option;
        this.renderingImageLabel = selectedItems.option['src'];
      if (selectedItems.option['ariaLabel']) {
        this.ariaLabel = selectedItems.option['ariaLabel'];
      } else {
        this.ariaLabel = this.customTitle;
      }
    }
    if (!this.isCombobox && !this.isTypeahead) {
      if (this.customTitle.indexOf('Selected') === -1) {
        this.ariaLabel = this.ariaLabel + ' selected';
      }
    }
  }

  /**
   * reset dropdown title.
   */
  resetCustomTitle() {
    if (!this.isCombobox && !this.isTypeahead) {
      if (this.ariaLabel !== this.ariaLabelDefault) {
        this.ariaLabel = this._heading;
      }
      this.customTitle = this.heading;
    }
    if (this.type === 'multiSelect') {
      this.customTitle = this.placeholder;
    }
  }

  // Handling events on multiSelect onclose
  selectOnClose() {
    this.propagateModelChange(this.model);
    if (this.retrieveFieldName) {
      this.onSelect.emit(this.model[this.retrieveFieldName] || this.model.value || this.model[this.renderingLabel]);
    } else {
      this.onSelect.emit(this.model);
    }
  }

  // Handling multiSelect onclose
  multiselectOnClose() {
    this.model = this.getSelectedItems();
    this.selectOnClose();
    if (this.isMultiSearchSelect) {
      this.calculatePosition();
    }
  }

  // Function executed when dropdown opens/closes
  toggleList() {
    if (!this.isPageContentSearch) {
      this.isOpen = !this.isOpen;
      this.active = !this.active;
      if (!this.isOpen) {
        if (this.type === 'multiSelect') {
          this.multiselectOnClose();
        }
        // to update text value of combox and typeahead from model value on close
        if (this.clearOnFocusOut) {
          setTimeout(() => {
            if (this.isTouchedOutside) {
              if (this.model && typeof this.model === 'object') {
                this.customTitle = this.model[this.renderingLabel];
                if (this.isCombobox) {
                  this.comboBoxContent = this.customTitle;
                } else if (this.isTypeahead) {
                  this.typeaheadContent = this.customTitle;
                }
              } else if (this.model && typeof this.model === 'string') {
                this.customTitle = this.model;
                if (this.isCombobox) {
                  this.comboBoxContent = this.customTitle;
                } else if (this.isTypeahead) {
                  this.typeaheadContent = this.customTitle;
                }
              }
            }
          }, 0);
        }
        if (this.isMultiSearchSelect) {
          this.multiSearchText = '';
        }
        // To destroy instance of axisInclude without dataprovider
        if (this.axisIncludeComponent && !this.dataProvider) {
          if (this.axisIncComponentRef) {
            this.axisIncComponentRef.destroy();
          }
        }
        if (this.isActionMenu || this.isTypeahead) {
          this.elRef.nativeElement.querySelector('#ddLabel' + this.ucid).focus();
        }
        this.hideDropdown();
      } else {
        this.elRef.nativeElement.focus();
        // Creates dynamic instance for axisInclude
        if (this.axisIncludeComponent && !this.dataProvider) {
          const factory = this.resolver.resolveComponentFactory(
            this.axisIncludeComponent
          );
          this.axisIncComponentRef = this.container.createComponent(factory);
          this.axisIncComponentRef.instance.data = this.context;
          this.axisIncComponentRef.instance.componentRef = this;
          if (this.inpCompContainer && this.inpCompContainer.nativeElement) {
            this.inpCompContainer.nativeElement.appendChild(
              this.axisIncComponentRef.location.nativeElement
            );
          }
        }

        if (!this.isPageContentSearch) {
          this.displayDropdown();
        }
      }
      this.openClose.emit({ isOpen: this.isOpen });
    }
  }

  // Updates model value for user entered value in combobox and typeahead
  updateModelValue(textVal) {
    this.model = {};
    this.model[this.renderingLabel] = textVal;
    this.model['isSelected'] = true;
    this.propagateModelChange(this.model);
    if (this.retrieveFieldName) {
      this.onSelect.emit(textVal);
    } else {
      this.onSelect.emit(this.model);
    }
    this.previousText = '';
  }

  // Creates dynamic component of dropdown list
  displayDropdown() {
    this.isClosed = false;
    if (this.isCombobox) {
      this.renderer2.setAttribute(this.elRef.nativeElement, 'aria-expanded', 'true');
      this.renderer2.setAttribute(this.elRef.nativeElement, 'aria-owns', 'ddListbox' + this.ucid);
      this.renderer2.setAttribute(this.elRef.nativeElement.children[0], 'aria-controls', 'ddListbox' + this.ucid);
    }
    else if ((this.kind === 'link' || this.kind === 'button' || this.kind === 'custom') && !this.isMultiSearchSelect && !this.isTypeahead &&
      !this.isActionMenu && !this.isPageContentSearch) {
      this.renderer2.setAttribute(this.elRef.nativeElement, 'aria-owns', 'ddListbox' + this.ucid);
      this.renderer2.setAttribute(this.elRef.nativeElement.children[0], 'aria-controls', 'ddListbox' + this.ucid);
    }
    // Destroy any existing dropdown instance
    if (
      this.isDataproviderChanged &&
      (this.componentRef || this.axisIncComponentRef)
    ) {
      this.hideDropdown();
      this.isDataproviderChanged = false;
    }
    if (!this.componentRef) {
      // Apply styles to body if it is outside of action tooltip
      this.scrollYPosition = !document.body.classList.contains(
        'axis-tooltip-open'
      )
        ? window.pageYOffset
        : parseInt(document.body.style.top, 10) * -1;
      if (!document.body.classList.contains('axis-tooltip-open')) {
        document.body.style.top = -this.scrollYPosition + 'px';
        document.body.style.position = 'fixed';
        if (document.body.scrollHeight > window.innerHeight) {
          document.body.classList.add('axis-dropdown-open');
        } else {
          document.body.classList.add('axis-dropdown-hidden-scroll');
        }
      }
      const componentFactory = this.resolver.resolveComponentFactory(
        DropdownMenuComponent
      );
      this.componentRef = componentFactory.create(this.injector);
      this.componentRef.instance.wrap = this.wrap;
      if (this.type === 'multiSelect' || this.type === 'radio' || this.isNestedMultiselect) {
        this.componentRef.instance.hasAxisCustom = true;
      }
      this.applicationRef.attachView(this.componentRef.hostView);
      this.setDropdownProperties();
      this.appendChildToMenu();
      this.addRendererListeners();
      this.componentRef.instance.resizeEvent.subscribe(event => this.onResize());
      if ((this.kind === 'button' || this.kind === 'link')
        && !this.renderingImageLabel && !this.columns && !this.isNestedMultiselect && !this.menuMinWidth && this.wrap) {
        this.setMaxWidth();
      }
      this.hasWidthChanged = false;
      this.setMinWidth();
      let optionElements: any;

      if (this.model && this.showSelected) {
        if (this.axisIncludeComponent && !this.dataProvider) {
          optionElements = this.axisIncludeRef.nativeElement.querySelector('a.selected');
        } else {
          optionElements = this.dropdownMenu.nativeElement.querySelector('a.selected');
        }

        if (!this.isCombobox && !this.isMultiSearchSelect && !this.isTypeahead &&
          this.type !== 'multiSelect' && !this.isNestedMultiselect) {
          setTimeout(() => {
            if (optionElements !== null) {
              optionElements.focus();
            }

            this.dropdownListArray.forEach((link, index) => {
              if (link.option.isSelected) {
                this.elementIndex = index;
              }
            });
            if (this.searchIcon  && this.isOpen) {
              this.searchIcon.nativeElement.focus();
              this.elementIndex = 0;
          }
          });
        } else if (this.isMultiSearchSelect) {
          setTimeout(() => {
            if (this.elementIndex < -1) {
              this.elementIndex = -1;
            }
          });
        }
      } else {
        if (this.axisIncludeComponent && !this.dataProvider) {
          optionElements = this.axisIncludeRef.nativeElement.querySelectorAll('[role="option"],[role="searchbox"]');
        } else {
          optionElements = this.dropdownMenu.nativeElement.querySelectorAll('[role="option"],[role="searchbox"]');
        }

        if (!this.isCombobox && !this.isMultiSearchSelect && !this.isTypeahead && !this.isSelectAll) {
          setTimeout(() => {
            if (optionElements && optionElements.length > 0) {
              optionElements[0].focus();
              this.elementIndex = 0;
            }
          });
        } else if (this.isMultiSearchSelect) {
          setTimeout(() => {
            this.elementIndex = -1;
          });
        } else {
          this.elementIndex = -1;
        }
      }
    }
    this.calculatePosition();
    this.addDocumentPositionListener();
    if (this.elRef.nativeElement.previousElementSibling) {
      if (this.elRef.nativeElement.previousElementSibling.tagName === 'LABEL') {
        this.labelId = this.elRef.nativeElement.previousElementSibling.id;
      }
    }
    else {
      this.labelId = 'ddLabel' + this.ucid;
    }

    this.isClicked = true;
    setTimeout(() => {
      this.changeDetectorRef.markForCheck();
      }, 200);
    this.changeDetectorRef.detectChanges();
  }

  // Destroys instance and remove body styles
  hideDropdown() {
    if (this.searchIcon  && !this.isOpen) {
      this.searchFilterText = '';
      this.isNoResults = false;
      this.dataProviderCopy = this._dataProvider;
  }
    this.selectedListId = '';
     if (this.isCombobox) {
      this.renderer2.setAttribute(this.elRef.nativeElement, 'aria-expanded', 'false');
      this.renderer2.removeAttribute(this.elRef.nativeElement, 'aria-owns');
      this.renderer2.removeAttribute(this.elRef.nativeElement.children[0], 'aria-controls');
    }
    else if ((this.kind === 'link' || this.kind === 'button' || this.kind === 'custom') && !this.isMultiSearchSelect && !this.isTypeahead &&
      !this.isActionMenu && !this.isPageContentSearch) {
        this.renderer2.removeAttribute(this.elRef.nativeElement, 'aria-owns');
        this.renderer2.removeAttribute(this.elRef.nativeElement.children[0], 'aria-controls');
    }
    if (this.componentRef || this.axisIncComponentRef) {
      // isClosed ignored at typeahead at hide dropdown as  typeahead works when user types
      if (!this.isTypeahead) {
        this.isClosed = true;
      }
      this.isClicked = false;
      this.removeRendererListeners();
      this.unbindResizeEvent();
      this.unbindScrollEvent();
      this.destroyDropdownInstance();
      if (!document.body.classList.contains('axis-tooltip-open')) {
        document.body.classList.remove('axis-dropdown-open');
        document.body.classList.remove('axis-dropdown-hidden-scroll');
        document.body.style.position = '';
        document.body.removeAttribute('style');
        window.scrollTo(0, this.scrollYPosition);
      }
      this.previousText = '';
      this.target = null;
      if (this.isObjectEnabled && this.type !== 'multiSelect' && this.dataProvider.length > 0) {
        this.dropdownListArray = [];
      }
    }
  }

  // START - Few multi search select specific methods.

  /**
   * called from the click event from the multi search select dropdown div.
   * and set focus to input element and open the dropdown.
   */
  focusInput(): void {
    if (this.multiSearchSelect && this.multiSearchSelect.nativeElement) {
      this.multiSearchSelect.nativeElement.focus();
      this.openMultiSearchSelectDropdownOnClick();
    }
  }

  tabMultiSearchSelect(): void {
    this.toggleList();
  }
  removeAllSharedSelectedItems() {
    this.selectedItems.forEach(data => {
      const index = this.dataProvider.findIndex(element =>
        element[this.renderingLabel] === data[this.renderingLabel]
        );
      if (index > -1) {
        this.dataProvider[index]['isSelected'] = false;
      }
    });
  }
  // Reset all selected items in multi search select
  removeAllSelectedItems() {
    if (this.dataShared) {
      this.removeAllSharedSelectedItems();
    } else {
      this.dataProvider.forEach(data => {
        data['isSelected'] = false;
      });
  }
  this.multiSearchText = '';
  this.selectedItems = [];
  this.multiselectOnClose();
 }

  /**
   * Called on multi search select escape event.
   * @param event
   */
  stop(event): void {
    event.preventDefault();
    event.stopPropagation();
  }

  /**
   * called from the focus event of multi search select dropdown.
   */
  focusMultiSearchSelectDropdown() {
    setTimeout(() => {
      this.isClosed = false;
    });
    this.typedText = '';
    this.onTouchedEmitter.emit();
  }

  /**
   * called on click event of multi search select dropdown and opens the dropdown.
   */
  openMultiSearchSelectDropdownOnClick() {
    if (!this.isOpen && !this.multiSearchText) {
      this._openCombobox();
      this.focusComboBox();
    }
    this.onTouchedEmitter.emit();
  }

  /**
   * Called on space event on multi search select dropdown and
   * opens the dropdown and display list, only when no text is entered.
   * @param event as HTMLElement
   */
  openMultiSearchSelectDropdownOnSpace(event) {
    if (!this.isOpen && !this.multiSearchText) {
      event.preventDefault();
      this._openCombobox();
      this.focusComboBox();
    }
  }

  /**
   * Called on enter event of multi search select dropdown.
   * Checks and update value of multi search select dropdown based on regular expression passed as input.
   * This will add any entered value in the selection if it matches the provided regExp.
   * Else it will clear the entered text and opens the dropdown.
   */
  updateValue(event) {
    event.preventDefault();
    if (this.regExp && this.multiSearchText && this.multiSearchText.match(this.regExp)) {
      this.addUserEntryInSelectedItems();
    } else {
      this.customTitle = '';
    }
    this.multiSearchText = '';
    this.searchFilter('');
  }

  /**
   * This will be called only when user provided regExp passed with the entered text in multi search select dropdown.
   * This will add user entered custom text which is not present in the dataprovider list
   * in the selected items list of multi search select dropdown.
   */
  addUserEntryInSelectedItems() {
    const renderingLabel: any = this.renderingLabel;
    let selectedListItem: any = {};
    let index;
    let existInList = false;
    for (let i = 0; i < this.selectedItems.length; i++) {
      if (
        this.typedText.toString() ===
        this.selectedItems[i][renderingLabel].toString()
      ) {
        return;
      }
    }
    for (let i = 0; i < this.dataProviderCopy.length; i++) {
      if (
        this.typedText.toString() ===
        this.dataProviderCopy[i][renderingLabel].toString()
      ) {
        this.dataProviderCopy[i]['isSelected'] = true;
        index = this.dataProvider.indexOf(this.dataProviderCopy[i]);
        existInList = true;
      }
    }
    if (!existInList) {
      selectedListItem[renderingLabel] = this.typedText;
    } else {
      selectedListItem = this.dataProvider[index];
      selectedListItem['index'] = index;
    }
    selectedListItem['isSelected'] = true;
    this.selectedItems.push(selectedListItem);
    this.model = this.selectedItems;
    this.propagateModelChange(this.model);
    if (this.retrieveFieldName) {
      this.onSelect.emit(this.model[this.retrieveFieldName] || this.model.value || this.model[this.renderingLabel]);
    } else {
      this.onSelect.emit(this.model);
    }
  }

  // END - Few multi search select specific methods.

  // Set values to dropdodown menu componernt
  setDropdownProperties() {
    this.componentRef.instance.isOpen = this.isOpen;
    if (this.elRef.nativeElement.attributes['data-col']) {
      this.componentRef.instance.col = this.elRef.nativeElement.attributes[
        'data-col'
      ].value;
    }
    if (this.type === 'radio' || this.type === 'multiSelect') {
      this.componentRef.instance.isMultiSelect = true;
    }
    if (this.kind === 'icon' || this.kind === 'link') {
      this.componentRef.instance.isIcon = true;
      if (
        this.elRef.nativeElement.attributes['data-align'] &&
        this.elRef.nativeElement.attributes['data-align'].value === 'right'
      ) {
        this.componentRef.instance.isIconAlignRight = true;
      }
    }
  }
  // Append componentReference to body
  appendChildToMenu() {
    this.containerEl.appendChild(this.componentRef.location.nativeElement);
    if (this.axisIncludeComponent && !this.dataProvider) {
      this.componentRef.location.nativeElement.appendChild(
        this.axisIncludeRef.nativeElement
      );
    } else {
      this.componentRef.location.nativeElement.appendChild(
        this.dropdownMenu.nativeElement
      );
    }
  }
  // Destroy dropdown instances
  destroyDropdownInstance() {
    if (this.componentRef) {
      const menuElement = this.componentRef.location.nativeElement;
      if (menuElement && menuElement.parentNode) {
        menuElement.parentNode.removeChild(menuElement);
      }
      this.componentRef.destroy();
      this.componentRef = null;
    }
    if (this.axisIncComponentRef) {
      this.axisIncComponentRef.destroy();
      this.axisIncComponentRef = null;
    }
  }
  closeDropDown() {
    this.isOpen = !this.isOpen;
    this.active = !this.active;
  }

  // START - Few combobox specific methods.

  // add listener for combobox arrow icon click.
  addComboboxClickEvent() {
    if (this.inputArea) {
      this.inputArea.nativeElement.parentElement.addEventListener('click', this.comboboxArrowClick.bind(this));
    }
  }

  // listener method for combobox arrow icon click.
  comboboxArrowClick() {
    if (!this.isComboboxFocus && !this.model && !this.disabled) {
      this._openCombobox();
    }
    if (!this.disabled) {
      this.elRef.nativeElement.children[0].focus();
      this.focusComboBox();
    }
  }

  removeComboboxClickEvent() {
    if (this.inputArea) {
      this.inputArea.nativeElement.parentElement.removeEventListener('click', this.comboboxArrowClick.bind(this));
    }
  }

  /**
   * called from the focus event of combobox.
   */
  focusComboBox() {
    this.isComboboxFocus = true;
    this.typedText = '';
    setTimeout(() => {
      this.isClosed = false;
    });
    this.onTouchedEmitter.emit();
  }

  /**
   * Open combobox on mouse click.
   * @param searchText as string
   */
  openComboboxOnClick(searchText: string) {
    this.focusComboBox();
    if (!this.isOpen && !searchText) {
      this._openCombobox();
    }
    this.onTouchedEmitter.emit();
  }

  /**
   * open combobox on pressing space.
   * @param event
   */
  openComboboxOnSpace(event) {
    if (!this.isOpen && !this.model) {
      event.preventDefault();
      this._openCombobox();
      this.focusComboBox();
    }
    if (this.model) {
      event.preventDefault();
    }
  }

  // Open combobox list on backspace.
  openComboboxOnBackspace() {
    if (!this.isOpen) {
      this.focusComboBox();
    }
  }

  // Open combobox and display list.
  private _openCombobox() {
    if (this.isOpen) {
      return;
    } else {
      this.isOpen = true;
      this.isDataproviderChanged = false;
      if (this.dataProvider && this.dataProvider.length > 0) {
        this.loadDropdownList();
      }
      this.displayDropdown();
    }
  }

  // Select first item from the combobox list on enter key press if model is null
  selectFirstItem(event: Event) {
    if (this.isOpen) {
      if (this.dataProviderCopy.length > 0 && !this.model) {
        const item: any = this.dataProviderCopy[0];
        if (this.dropdownListArray.length > 0) {
          const selectedListItemIndex: number = this.dropdownListArray.findIndex(x => x.option === item);
          if(selectedListItemIndex !== -1) {
            this.dropdownListArray[selectedListItemIndex].selectOption(event);
            this.isListItem = true;
          }
        }
      }
      this.isClosed = false;
    }
  }

  // Select item on tab key press if dataprovidercopy length is one
  selectTabItem(event: Event) {
    const key = event['key'].toLocaleLowerCase();
    if (key === 'tab' && this.dataProviderCopy && this.dataProviderCopy.length === 1 && this.typedText) {
        const listItem = this.dropdownListArray.find(x => x.option[this.renderingLabel] === this.dataProviderCopy[0][this.renderingLabel]);
        if (listItem) {
          listItem.selectOptionOnKeyDown(event);
        }
        this.isListItem = true;
    }
  }

  // END - Few combobox specific methods.

  isArray(obj) {
    return Array.isArray(obj);
  }

  // Compares model value with dataprovider values
  compareObjects(obj1, obj2): boolean {
    const comparator1 = Object.assign({}, obj1);
    const comparator2 = Object.assign({}, obj2);
    if (comparator1.hasOwnProperty('isSelected')) {
      delete comparator1.isSelected;
    }
    if (comparator2.hasOwnProperty('isSelected')) {
      delete comparator2.isSelected;
    }
    if (comparator1.hasOwnProperty('subSection')) {
      delete comparator1.subSection;
    }
    if (comparator2.hasOwnProperty('subSection')) {
      delete comparator2.subSection;
    }
    return this.isEquivalent(comparator1, comparator2);
  }

  isEquivalent(obj1, obj2) {
    const obj1Props = Object.getOwnPropertyNames(obj1);
    const obj2Props = Object.getOwnPropertyNames(obj2);
    if (obj1Props.length !== obj2Props.length) {
      return false;
    }
    for (let i = 0; i < obj1Props.length; i++) {
      const propName = obj1Props[i];
      if (obj1[propName] !== obj2[propName]) {
        if (Array.isArray(obj1[propName]) && Array.isArray(obj2[propName]) && obj1[propName].length === obj2[propName].length) {
          for (let j = 0; j < obj1[propName].length; j++) {
            if (!this.compareObjects(obj1[propName][j], obj2[propName][j])) {
              return false;
            }
          }
        } else {
          return false;
        }
      }
    }
    return true;
  }

  // Function to select value from ngModel
  preDefinedSelection(model) {
    // model is either object or Array of objects
    this.resetSelection();
    let selectedListItem;
    if (this.isArray(model)) {
      // Array of objects
      model.forEach(item => {
        this.dropdownListArray.forEach(d => {
          if (this.compareObjects(d.option, item)) {
            d.isSelected = true;
            d.option.isSelected = true;
            if (this.isMultiSearchSelect) {
              selectedListItem = d.option;
              selectedListItem['index'] = this.dataProvider.indexOf(
                selectedListItem
              );
              this.selectedItems.push(selectedListItem);
            } else if (model && this.type === 'multiSelect' && this.isSelectAll) {
              // mutliselect dropdown with ngmodel,checked
              let checked = 0, enabledItemsCount = 0, disable = true;
              this.selectedItems = [];
              this.dropdownListArray.forEach(child => {
                if (child.option.checked === true) {
                  child.isSelected = true;
                  child.option.isSelected = true;
                  checked++;
                  this.selectedItems.push(child.option);
                  this.model = this.selectedItems;
                } else {
                  child.isSelected = false;
                  child.option.isSelected = false;
                }
                if (!child.disabled) {
                  enabledItemsCount++;
                }
                if (child.option.checked === false) {
                  disable = false;
                }
              });
              if (checked >= enabledItemsCount && disable === true) { // selectall is true
                this.selectAllChecked = true;
              } else {
                this.selectAllChecked = false; // selectall is false
              }
            } else {
              this.selectedItems.push(d.option);
            }
            if (this.isNestedMultiselect) {
              if (d.option.children && d.option.children.length > 0) {
                d.option.children.forEach(child => {
                  child.isSelected = true;
                  child.subSection = d.option[this.renderingLabel];
                });
              }
            }
          } else {
            const subSection = item['subSection'];
            if (this.isNestedMultiselect && item['subSection'] === d.option[this.renderingLabel]) {
              if (d.option.children && d.option.children.length > 0) {
                d.option.children.forEach(child => {
                  if (this.compareObjects(item, child)) {
                    child.isSelected = true;
                    child.subSection = subSection ? subSection : d.option[this.renderingLabel];
                    this.selectedItems.push(child);
                  }
                });
              }
            }
          }
        });
      });
      this.renderTitle(this.model);
    } else if (typeof model === 'number') {
      if (this.retrieveFieldName) {
        this.preSelect(model);
      } else {
        let label = 'value';
        const index = model;
        if (this.dataProvider && this.dataProvider.length > 0) {
          label = this.renderingLabel;
        }
        if (this.dropdownListArray && this.dropdownListArray.length > 0) {
          this.dropdownListArray.forEach((d, i) => {
            if (i === index) {
              d.option.isSelected = true;
              d.isSelected = true;
              if (this.isMultiSearchSelect) {
                selectedListItem = d.option;
                selectedListItem['index'] = this.dataProvider.indexOf(
                  selectedListItem
                );
                this.selectedItems.push(selectedListItem);
              } else {
                this.selectedItems.push(d.option);
              }
              this.model = d.option;
              this.customTitle = d.option[label];
            }
          });
        } else {
          if (this.dataProvider && index < this.dataProvider.length) {
            this.model = this.dataProvider[index];
            this.dataProvider[index]['isSelected'] = true;
            this.customTitle = this.dataProvider[index][label];
          }
        }
      }
    } else if (typeof model === 'string') {
      this.preSelect(model);
    } else {
      // object
      this.dropdownListArray.forEach(d => {
        if (this.compareObjects(d.option, model)) {
          d.isSelected = true;
          d.option.isSelected = true;
          if (this.isMultiSearchSelect) {
            selectedListItem = d.option;
            selectedListItem['index'] = this.dataProvider.indexOf(
              selectedListItem
            );
            this.selectedItems.push(selectedListItem);
          } else {
            this.selectedItems.push(d.option);
          }
          if (this.isNestedMultiselect) {
            if (d.option.children && d.option.children.length > 0) {
              d.option.children.forEach(child => {
                child.isSelected = true;
                child.subSection = d.option[this.renderingLabel];
              });
            }
          }
        } else {
          if (this.isNestedMultiselect && model.subSection === d.option[this.renderingLabel]) {
            if (d.option.children && d.option.children.length > 0) {
              d.option.children.forEach(child => {
                if (this.compareObjects(model, child)) {
                  child.isSelected = true;
                  this.selectedItems.push(child);
                }
              });
            }
          }
        }
      });
      if (this.model) {
        this.model['isSelected'] = true;
        this.customTitle =
          this.model[this.renderingLabel] ||
          this.model['value'] ||
          this.model['label'];
        this.renderingImageLabel = this.model['src'];
        this.renderingIcon = this.model;
      }
    }
    if (this.isTypeahead) {
      this.typeaheadContent = this.customTitle;
    }
    if (this.isCombobox) {
      this.comboBoxContent = this.customTitle;
      this.ariaLabel = '';
    }
    if (this.isPageContentSearch) {
      this.searchFilterText = this.customTitle;
    }
  }

  /**
   * pre select the model value in the dropdown.
   * If 'retrieveFieldName' is given then pre select that option whose property matches with retrieveFieldName
   * and same property value matched with ngModel.
   * @param model as string | number
   */
  preSelect(model) {
    let selectedListItem: any;
    let label = 'value';
    if (this.dataProvider && this.dataProvider.length > 0) {
      label = this.renderingLabel;
    }
    if (this.dropdownListArray && this.dropdownListArray.length > 0) {
      this.dropdownListArray.forEach(d => {
        if ((!this.retrieveFieldName && d.option[label] === model) || (this.retrieveFieldName && d.option[this.retrieveFieldName] === model)) {
          d.option.isSelected = true;
          d.isSelected = true;
          if (this.isMultiSearchSelect) {
            selectedListItem = d.option;
            selectedListItem['index'] = this.dataProvider.indexOf(
              selectedListItem
            );
            this.selectedItems.push(selectedListItem);
          } else {
            this.selectedItems.push(d.option);
          }
          this.model = d.option;
          this.customTitle = d.option[label];
          if (d.option['ariaLabel'] !== undefined) {
            this.ariaLabel = d.option['ariaLabel'];
          }
        }
      });
    } else if (this.model) {
      this.customTitle =
        typeof this.model === 'string' ? this.model : this.model[label];
    }
  }

  // Removes selection of current item from multi search select
  removeSelection(index, i) {
    this.selectedItems.splice(i, 1);
    if (typeof index === 'number' && this.dataProvider[index]) {
      this.dataProvider[index]['isSelected'] = false;
    }
    this.multiselectOnClose();
  }

  /*Below function will execute when listitem is selected, called from AxisDropDownListComponent */
  notifyChange(item: DropdownListComponent) {
    if (this.isMultiSearchSelect) {
      let selectedListItem;
      if (item.option.isSelected) {
        selectedListItem = item.option;
        selectedListItem['index'] = this.dataProvider.indexOf(selectedListItem);
        this.selectedItems.push(item.option);
      }
      this.multiSearchText = null;
      this.searchFilter('');
      this.multiselectOnClose();
      this.elementIndex--;
    }
    if (
      (this.type === 'select' ||
        this.type === 'filter' ||
        this.type === 'radio' ||
        this.isPageContentSearch) &&
      !this.isMultiSearchSelect
    ) {
      this.renderTitle(item);
      if (this.isTypeahead) {
        this.typeaheadContent = this.customTitle;
      }
      if (this.isCombobox) {
        this.comboBoxContent = this.customTitle;
        this.focusComboBox();
      }
      if (this.isPageContentSearch) {
        this.searchFilterText = this.customTitle;
      }
      this.isTouchedOutside = false;
      this.toggleList();
      this.model = item.option;
      this.selectOnClose();
      this.arrowKey = false;
    } else if (this.type === 'multiSelect') {
      if (this.isNestedMultiselect && this.readonlyHeaders) {
        this.selectedItems = [];
        if (item.option.children && item.option.children.length > 0) {
          item.option.children.forEach(child => {
            if (child.isSelected) {
              child.subSection = item.option[this.renderingLabel];
              this.selectedItems.push(child);
            }
          });
        }
        this.toggleList();
        this.selectOnClose();
      } else if (this.isNestedMultiselect) {
        if (item.option.isSelected) {
          if (item.option.children && item.option.children.length > 0) {
            item.option.children.forEach(child => {
              const index = this.isContains(child);
              if (index > -1) {
                this.selectedItems.splice(index, 1);
              }
            });
          }
          this.selectedItems.push(item.option);
        } else {
          const index = this.isContains(item.option);
          if (index > -1) {
            this.selectedItems.splice(index, 1);
          }
          if (item.option.children && item.option.children.length > 0) {
            item.option.children.forEach(child => {
              const newIndex = this.isContains(child);
              if (newIndex > -1) {
                this.selectedItems.splice(newIndex, 1);
              }
              if (child.isSelected) {
                child.subSection = item.option[this.renderingLabel];
                this.selectedItems.push(child);
              }
            });
          }
        }
      } else {
        const index = this.isContains(item.option);
        if (index > -1) {
          this.selectedItems.splice(index, 1);
        }
        if (item.option.isSelected) {
          this.selectedItems.push(item.option);
        }

        if (this.isSelectAll) {
          let count = 0;
          let enabledItemsCount = 0;
          this.dropdownListArray.forEach(child => {
            if (child.isSelected) {
              count++;
            }
            if (!child.disabled) {
              enabledItemsCount++;
            }
          });
          if (count >= enabledItemsCount) {
            this.selectAllChecked = true;
          } else {
            this.selectAllChecked = false;
          }
        }
      }
      this.selectedItems.length > 0
        ? this.renderTitle(this.selectedItems)
        : this.resetCustomTitle();
        this.onMultiSelect.emit(this.selectedItems);
    }
  }

  stopPropagation(event:any) {
    if (event.stopPropagation) {
      event.stopPropagation();
    }
  }

  // search functionality for filter type dropdown
  searchFilter(searchText) {
    if (!this.isClosed) {
      this.isListItem = false;
      this.typedText = searchText;
      if (!this.isSearchTextEventEmitted) {
        this.onSearchText.emit(this.typedText);
      }
      this.isNoResults = false;
      if (searchText && this.dataProvider && this.clientSideValidation) {
        this.searchPopulateDataProviderCopy(
          searchText,
          this.noOfSearchResultsList
        );
        if (!this.isPageContentSearch) {
          this.isOpen = true;
        }
        if (!this.changeDetectorRef['destroyed']) {
          this.changeDetectorRef.detectChanges();
        }
        if (this.isPageContentSearch) {
          this.resetOnBlur();
        }
        if (this.dataProviderCopy.length === 0) {
          this.isNoResults = true;
          if (!this.isMultiSearchSelect && this.clearOnFocusOut) {
            this.resetOnBlur();
          }
        }
        if (this.isMultiSearchSelect && this.dataProviderCopy) {
          for (let i = 0; i < this.dataProviderCopy.length; i++) {
            if (this.dataProviderCopy[i]['isSelected']) {
              this.isNoResults = true;
            } else {
              this.isNoResults = false;
              break;
            }
          }
        }
      } else {
        if (!this.isPageContentSearch) {
          this.isOpen = true;
        }
        if (!this.isMultiSearchSelect && this.clearOnFocusOut) {
          this.resetOnBlur();
          this.resetSelection();
        }
        if (this.dataProvider && this.dataProvider.length > 0) {
          this.loadDropdownList();
        }
      }
      if (!this.isPageContentSearch && !this.searchIcon) {
        this.displayDropdown();
      }
    }
  }

  // START - Few typeahead specific methods.

  /**
   * Typeahead feature helper function.
   * function for the typeahead 'apiCall' property url subscription.
   */
  typeaheadApiCallUrlSubscription() {
    this.typeaheadApiCallUrlEvent
      .pipe(debounceTime(500),
        switchMap(() => this.getNewData(this.apiCall)
          .pipe(
            catchError(() => {
              this.isObjectEnabled = true;
              return of([]);
            })
          ))
      ).subscribe(resp => {
        this.isObjectEnabled = false;
        if (Array.isArray(resp)) {
          if (!this.isSameArray(resp)) {
            this.dataProvider = resp;
          }
        } else {
          if (!this.isSameArray(resp['data'])) {
            this.dataProvider = resp['data'];
          }
        }
        this._typeaheadSearch(this.typedText);
        this.onDataproviderSubscription.emit();
      },
        error => {
          console.error('Could not reach API call on Typeahead component.', error);
          if (this.dataProvider.length > 0) {
            this.dataProvider = [];
          }
          this._typeaheadSearch(this.typedText);
        }
      );
  }

  /**
   * Typeahead feature helper function.
   * function for the typeahead 'apiCall' property callback method subscription.
   */
  typeaheadApiCallFunctionSubscription() {
    this.typeaheadApiCallFunctionEvent
      .pipe(debounceTime(500),
        takeWhile(() => this.alive),
        switchMap(() => this.apiCall(this.typeaheadContent).
        pipe(
          catchError((err) => {
            this.isObjectEnabled = true;
            return of(`API callback returned error: ${err}`);
          })
        ))
      ).subscribe(
        resp => {
          if (Array.isArray(resp)) {
            if (!this.isSameArray(resp)) {
              this.dataProvider = resp;
            }
          } else {
            if (!this.isSameArray(resp['data'])) {
              this.dataProvider = resp['data'];
            }
          }
          this._typeaheadSearch(this.typedText);
          this.onDataproviderSubscription.emit();
        },
        error => {
          console.error('Could not reach API call on Typeahead component.', error);
          if (this.dataProvider.length > 0) {
            this.dataProvider = [];
          }
          this._typeaheadSearch(this.typedText);
        }
      );
  }

  /**
   * get the data from the url.
   * @param url as string - url to be triggered.
   * @return Observable
   */
  getNewData(url): any {
    return this.httpClient.get(url + `${this.typeaheadContent}`);
  }

  /**
   * checks if the resp and dataprovider is same or not and return the status.
   * @param resp as Array
   * @return isSame as boolean
   */
  isSameArray(resp) {
    let isSame = true;
    if (resp && resp.length) {
      if (this.dataProvider && this.dataProvider.length) {
        if (this.dataProvider.length === resp.length) {
          isSame = this.dataProvider.every((e) => {
            return resp.indexOf(e) >= 0;
          });
          if (!isSame) {
            isSame = resp.every((e) => {
              return this.dataProvider.indexOf(e) >= 0;
            });
          }
        } else {
          isSame = false;
        }
      } else {
        isSame = false;
      }
    } else {
      if (this.dataProvider && this.dataProvider.length) {
        this.dataProvider = [];
      }
    }
    return isSame;
  }

  /**
    * called from the focus event of typeahead dropdown.
    */
  focusTypeahead() {
    setTimeout(() => {
      this.isClosed = false;
    }, 0);
  }
  /**
   * Typeahead feature helper function.
   * called when 'isTypeahead=true' from (ngModelChange) in template and set dataprovider function.
   * @param searchText as string - typed text in typeahead input.
   */
  typeaheadSearch(searchText) {
  if (!this.isClosed) {
    this.typedText = searchText;
    if (!this.apiCall) {
      this._typeaheadSearch(searchText);
    } else if (searchText && searchText.length >= this.triggerLength) {
      if (searchText !== this.previousText) {
        this.previousText = searchText;
        if (typeof this.apiCall === 'string') {
          this.typeaheadApiCallUrlEvent.next();
        } else {
          this.typeaheadApiCallFunctionEvent.next();
        }
      }
    } else {
      this._typeaheadSearch(searchText);
    }
  }
 }

  /**
   * Typeahead feature helper function.
   * @param searchText as string - typed text in typeahead input.
   */
  _typeaheadSearch(searchText) {
    this.typedText = searchText;
    if (!this.isSearchTextEventEmitted) {
      this.onSearchText.emit(this.typedText);
    }
    this.isSearchTextEventEmitted = false;
    this.isNoResults = false;
    this.isListItem = false;
    if (
      searchText &&
      searchText.length >= this.triggerLength &&
      this.dataProvider &&
      this.dataProvider.length
    ) {
      this.isOpen = true;
      if (this.apiCall) {
        this.dataProviderCopy = this.dataProvider;
        this.isMoreResults = false;
        if (this.dataProvider.length > this.noOfSearchResults) {
          this.dataProviderCopy.splice(this.noOfSearchResults, (this.dataProvider.length - this.noOfSearchResults));
          this.isMoreResults = true;
        }
      } else {
        this.searchPopulateDataProviderCopy(searchText, this.noOfSearchResults);
      }
      if (this.dataProviderCopy.length === 0) {
        this.isNoResults = true;
        if (this.clearOnFocusOut) {
          this.resetOnBlur();
        }
      }
      this.displayDropdown();
    } else {
      this.isNoResults = true;
      this.isObjectEnabled = true;
      this.dataProviderCopy = [];
      if (this.clearOnFocusOut) {
        this.resetOnBlur();
      }
      if (this.isTypeahead && this.typedText && this.typedText.length >= this.triggerLength) {
        this.isOpen = true;
        this.displayDropdown();
      } else {
        this.isOpen = false;
        this.hideDropdown();
      }
    }
  }
  // END - Few typeahead specific methods.

  // Filter combobox and typeahead list
  searchPopulateDataProviderCopy(searchText, noOfSearchResults) {
    let count = 0;
    const BreakException = {};
    this.dataProviderCopy = [];
    this.isMoreResults = false;
    if (!this.searchProperties) {
      this.searchProperties = this.renderingLabel;
    }
    try {
      this.dataProvider.forEach((element, index) => {
        if (this.isMultiSearchSelect && this.selectedItems && this.selectedItems.length) {
          const selectedItemIndex = this.selectedItems.findIndex(item => item[this.renderingLabel] === element[this.renderingLabel]);
          if (selectedItemIndex > -1) {
            return;
          }
        }
        if (noOfSearchResults && count >= noOfSearchResults) {
          throw BreakException;
        }
        if (typeof this.searchProperties === 'string') {
          if (this.filterStartsWith) {
            if (
              element[this.renderingLabel]
                .toString()
                .toLowerCase()
                .startsWith(searchText.toLowerCase())
            ) {
              count++;
              this.dataProviderCopy.push(element);
            }
          } else {
            if (
              element[this.renderingLabel]
                .toString()
                .toLowerCase()
                .indexOf(searchText.toLowerCase()) > -1
            ) {
              count++;
              this.dataProviderCopy.push(element);
            }
          }
        } else if (this.isArray(this.searchProperties)) {
          for (let i = 0; i < this.searchProperties.length; i++) {
            if (this.filterStartsWith) {
              if (
                element[this.searchProperties[i]]
                  .toString()
                  .toLowerCase()
                  .startsWith(searchText.toLowerCase())
              ) {
                count++;
                this.dataProviderCopy.push(element);
                break;
              }
            } else {
              if (
                element[this.searchProperties[i]]
                  .toString()
                  .toLowerCase()
                  .indexOf(searchText.toLowerCase()) > -1
              ) {
                count++;
                this.dataProviderCopy.push(element);
                break;
              }
            }
          }
        }
      });
    } catch (e) {
      if (e !== BreakException) {
        throw e;
      } else {
        this.isMoreResults = true;
        this.isDataproviderChanged = false;
      }
    }
    if (!this.changeDetectorRef['destroyed']) {
      this.changeDetectorRef.detectChanges();
    }
  }

  // Loads dropdown list items
  loadDropdownList() {
    if (this.noOfSearchResultsList) {
      let count = 0;
      const BreakException = {};
      this.dataProviderCopy = [];
      this.isMoreResults = false;
      try {
        this.dataProvider.forEach((element, index) => {
          if (count >= this.noOfSearchResultsList) {
            throw BreakException;
          } else {
            count++;
            this.dataProviderCopy.push(element);
          }
        });
      } catch (e) {
        if (e !== BreakException) {
          throw e;
        } else {
          this.isMoreResults = true;
        }
      }
    } else {
      if (this.multiSearchSelect) {
        this.dataProviderCopy = [];
        this.dataProvider.forEach(x=> {
          if (this.selectedItems.findIndex(item => item[this.renderingLabel] === x[this.renderingLabel]) === -1) {
            this.dataProviderCopy.push(x);
          }
        });
      } else {
        this.dataProviderCopy = Array.from(this.dataProvider);
      }
    }
    if (!this.changeDetectorRef['destroyed']) {
      this.changeDetectorRef.detectChanges();
    }
  }

  // Listener for document click event
  addDocumentListener() {
    this.unbindDocumentEvent = this.renderer2.listen(
      document,
      'click',
      (event: Event) => {
        event.stopPropagation();
        if (
          !this.elRef.nativeElement.contains(event.target) &&
          this.isOpen &&
          (this.isMultiSearchSelect &&
            !this.componentRef.location.nativeElement.contains(event.target))
        ) {
          this.multiSearchSelect.nativeElement.focus();
        } else if (
          event.target['innerText'] === 'No results found' ||
          event.target['innerText'] === this.moreResultsMessage
        ) {
          this.elRef.nativeElement.children[0].focus();
          this.resetTextInput();
        } else if (
          !this.elRef.nativeElement.contains(event.target) &&
          this.isOpen &&
          ((this.isMultiSearchSelect &&
            this.componentRef.location.nativeElement.contains(event.target)) ||
            (this.type === 'multiSelect' &&
              !this.dropdownMenu.nativeElement.contains(event.target)))
        ) {
          this.toggleList();
        } else if (
          !this.isMultiSearchSelect &&
          this.type !== 'multiSelect' &&
          !this.elRef.nativeElement.contains(event.target) &&
          this.isOpen &&
          event.target['innerText'] !== 'No data found'
        ) {
          this.toggleList();
        }
      }
    );
  }

  // To show hide multi column drodpown on hover
  addDocumentMouseOverListener() {
    this.unbindMouseOverEvent = this.renderer2.listen(
      document,
      'mouseover',
      (event: Event) => {
        if (
          !this.elRef.nativeElement.contains(event.target) &&
          this.elRef.nativeElement.attributes['data-col']
        ) {
          if (
            this.dropdownMenu &&
            this.dropdownMenu.nativeElement.contains(event.target)
          ) {
            this.isOpen = true;
            this.active = true;
            this.displayDropdown();
          } else {
            this.isOpen = false;
            this.active = false;
            this.hideDropdown();
          }
        }
      }
    );
  }

  addDocumentPositionListener() {
    this.unbindScrollEvent = this.renderer2.listen(window, 'scroll', () => {
      if (this.isOpen) {
        this.calculatePosition();
      }
    });

    this.unbindResizeEvent = this.renderer2.listen(window, 'resize', () => {
      if (this.isOpen) {
        this.calculatePosition();
      }
    });
  }

  // listener for keydown event
  bindKeyDownEvent() {
    this.unbindKeyEvent = this.renderer2.listen(
      document,
      'keydown',
      (event: KeyboardEvent) => {
        const key = event.key.toLocaleLowerCase();
        if (this.isOpen) {
          if (
            (!this.isCombobox || (this.isCombobox && this.keysCombobox.indexOf(key) > -1)) &&
            (!this.isTypeahead || (this.isTypeahead && this.keysCombobox.indexOf(key) > -1)) &&
            (!this.isMultiSearchSelect || (this.isMultiSearchSelect && this.keysMultiSearchSelect.indexOf(key) > -1)) &&
            (this.type !== 'filter' || (this.type === 'filter' && this.keysFilter.indexOf(key) > -1))
          ) {
            this.keyNavigation(event, key);
          }
        }
      }
    );
  }

  // Add event listeners on dropdown list display
  addRendererListeners() {
    if (this.closeOnOutsideClick) {
      this.addDocumentListener();
    }
    if (this.elRef.nativeElement.attributes['data-col']) {
      this.addDocumentMouseOverListener();
    }
    this.bindKeyDownEvent();
    this.isClosed = false;
  }

  // Removes event listeners on dropdown list hide
  removeRendererListeners() {
    if (typeof this.unbindDocumentEvent === 'function') {
      this.unbindDocumentEvent();
    }
    if (typeof this.unbindKeyEvent === 'function') {
      this.unbindKeyEvent();
    }
    if (typeof this.unbindMouseOverEvent === 'function') {
      this.unbindMouseOverEvent();
    }
    if (!this.isTypeahead) {
      this.isClosed = true;
    }

  }

  // Keyboard navigation logic
  keyNavigation(event, key) {
    let navigateVertical = true;

    let optionElements: any;
    if (this.axisIncludeComponent && !this.dataProvider) {
      optionElements = this.axisIncludeRef.nativeElement.querySelectorAll('[role="option"],[role="searchbox"]');
    } else if (this.isNestedMultiselect) {
      optionElements = this.dropdownMenu.nativeElement.querySelectorAll('axis-dropdown-list>[role="option"],axis-dropdown-list>ul>li>[role="option"],[role="searchbox"]');
    } else {
      optionElements = this.dropdownMenu.nativeElement.querySelectorAll('axis-dropdown-list>[role="option"],[role="searchbox"],.axis-dropdown-item[role="option"]');
    }

    switch (key) {
      case 'arrowdown':
      case 'down':
        event.preventDefault();
        this.arrowKey = true;
        if (optionElements.length === 0) { // when no results found in list
          this.dropdownMenu.nativeElement.focus();
        } else {
          this.skipDisabledItem(1, optionElements);
        }
        break;
      case 'arrowup':
      case 'up':
        event.preventDefault();
        this.arrowKey = true;
        if (optionElements.length === 0) { // when no results found in list
          this.dropdownMenu.nativeElement.focus();
        } else {
          this.skipDisabledItem(-1, optionElements);
        }
        break;
      case 'backspace':
        this.arrowKey = false;
        navigateVertical = false;
        this.elementIndex = -1;
        break;
      case 'end':
        event.preventDefault();
        this.arrowKey = true;
        this.elementIndex = optionElements.length - 1;
        break;
      case 'esc':
      case 'escape':
        this.arrowKey = false;
        navigateVertical = false;
        if (this.isOpen) {
          this.toggleList();
          this.elementIndex = 0; // reset index
          if (this.isMultiSearchSelect) {
            this.elRef.nativeElement.querySelector('#ddFilter' + this.ucid).focus();
          } else {
            this.elRef.nativeElement.querySelector('#ddLabel' + this.ucid).focus();
          }
        }
        break;
      case 'home':
        event.preventDefault();
        this.arrowKey = true;
        if (this.type === 'filter') {
          this.elementIndex = 1;
        } else {
          this.elementIndex = 0;
        }
        break;
      case 'shift':
        this.arrowKey = false;
        navigateVertical = false;
        break;
      case 'tab':
        this.arrowKey = false;
        navigateVertical = false;
        if (this.type === 'filter' || this.type === 'multiSelect' || this.isNestedMultiselect) {
          this.elRef.nativeElement.querySelector('#ddLabel' + this.ucid).focus();
          this.elementIndex = 0; // reset for return
        }
        this.toggleList();
        break;
      case 'enter':
        this.arrowKey = false;
        if (optionElements.length === 0) { // when no results found in list
          this.elRef.nativeElement.children[0].focus();
          this.elRef.nativeElement.children[0].value = '';
          this.toggleList();
        }
        break;
      default: // search option titles for matching character
        if (/[a-z0-9\/a()]/.test(key) && !this.isMultiSearchSelect) {
          this.keysSoFar = this.keysSoFar + event.key.toLocaleLowerCase();
          this.clearKeysSoFarAfterDelay();
          const searchChar = this.keysSoFar;
          const ol = optionElements.length - 1;
          let label;

          for (let index = ol; index >= 0; index--) {
            label = optionElements[index].innerText;
            if (label && label.toLocaleLowerCase().indexOf(searchChar) === 0) {
              this.elementIndex = index;
            }
          }
        }
        break;
    }
    if (optionElements !== undefined) {
      if (optionElements[this.elementIndex] && navigateVertical) {
        if (this.dropdownListArray[this.elementIndex]) {
          this.selectedListId = this.dropdownListArray[this.elementIndex].ucid;
        }
        optionElements[this.elementIndex].focus();
      }
    }
  }

  // Skips disabled list items on arrow key press
  skipDisabledItem(step, optionElements?) {
    let index = this.elementIndex;
    index += step;
    if (index < -1) { // out of range
      index = 0;
    } else if (index < 0) { // out of range
      return;
    } else if (index >= optionElements.length) { // out of range
      index = optionElements.length - 1;
    }
    this.elementIndex = index;
  }

  // Calculates position of dropdown list
  calculatePosition() {
    let menuElement: any;
    const hostElement = this.elRef.nativeElement;
    if (this.axisIncludeComponent && !this.dataProvider) {
      menuElement = this.axisIncludeRef.nativeElement;
    } else {
      menuElement = this.dropdownMenu.nativeElement;
    }
    setTimeout(() => {
      const posObj = hostElement.getBoundingClientRect();
      const menuPosObj = menuElement.getBoundingClientRect();
      this.smartPositioning(posObj, menuPosObj);
      this.renderer2.setStyle(menuElement, 'display', 'inherit');
    }, 0);
  }

  smartPositioning(posObj: any, menuPosObj: any) {
    const menuHeight = menuPosObj.height + 4;
      const bottomSpace = window.innerHeight - (posObj.bottom + menuHeight);
      const topSpace = posObj.top - menuHeight;
      if (bottomSpace > 0 || bottomSpace > topSpace) {
        this.bottomPositioning(posObj, menuPosObj);
      } else {
        this.topPositioning(posObj, menuPosObj, menuHeight);
      }
    }

  topPositioning(posObj: any, menuPosObj: any, menuHeight: number) {
    this.top = posObj.top - menuHeight + this.scrollYPosition;
    this.renderer2.setStyle(this.dropdownMenu.nativeElement, 'top', this.top + 'px');
    // this.renderer2.setStyle(this.dropdownMenu.nativeElement, 'left', posObj.left + 'px');
    if (
      this.elRef.nativeElement.attributes['data-align'] &&
      this.elRef.nativeElement.attributes['data-align'].value === 'right'
    ) {
      this.right = document.body.offsetWidth - posObj.right;
    } else {
      this.left = posObj.left;
      this.renderer2.setStyle(this.dropdownMenu.nativeElement, 'left', posObj.left + 'px');
    }
  }

  bottomPositioning(posObj: any, menuPosObj: any) {
    this.top = posObj.bottom + this.scrollYPosition;
    this.renderer2.setStyle(this.dropdownMenu.nativeElement, 'top', this.top + 'px');
    // this.renderer2.setStyle(this.dropdownMenu.nativeElement, 'left', posObj.left + 'px');
    if (
      this.elRef.nativeElement.attributes['data-align'] &&
      this.elRef.nativeElement.attributes['data-align'].value === 'right'
    ) {
      this.right = document.body.offsetWidth - posObj.right;
    } else {
      this.left = posObj.left;
      this.renderer2.setStyle(this.dropdownMenu.nativeElement, 'left', posObj.left + 'px');
    }
  }

  // To ratain or clear model value on focus out
  onTouchedEvent() {
    this.isComboboxFocus = false;
    if (!this.arrowKey && this.clearOnFocusOut) {
      if (
        (this.isTypeahead &&
        ((this.typedText && this.typedText.length >= this.triggerLength) ||
            this.model) || (this.isCombobox && (this.typedText || this.model)))
      ) {
        if (this.model) {
          this.isTouchedOutside = true;
        } else {
          this.resetTextInput();
        }
      } else if (this.isTypeahead || this.isCombobox) {
        this.resetTextInput();
      }
    } else if (!this.arrowKey && !this.clearOnFocusOut && !this.isListItem) {
      if (this.isCombobox && this.comboBoxContent) {
        this.updateModelValue(this.comboBoxContent);
      } else if (this.isTypeahead && this.typeaheadContent) {
        this.updateModelValue(this.typeaheadContent);
      } else {
        this.resetModel();
      }
      this.resetPrevSelection();
    } else if (this.type === 'multiSelect' && this.model && this.isSelectAll) {
      this.model = this.selectedItems;
    }
    this.arrowKey = false;
    this.onTouched();
  }

  resetTextInput() {
    this.model = null;
    this.resetSelection();
    this.isNoResults = false;
  }

  emitActionEvent() {
    this.actionEvent.emit();
  }

  clearKeysSoFarAfterDelay(): void {
    if (this.keyClear) {
      clearTimeout(this.keyClear);
      this.keyClear = null;
    }
    this.keyClear = setTimeout(() => {
      this.keysSoFar = '';
      this.keyClear = null;
    }, 500);
  }

  focusOption(event): void {
    event.preventDefault();
    this.toggleList();
  }

  ngOnDestroy() {
    this.alive = false;
    this.hideDropdown();
    if (!this.changeDetectorRef['destroyed']) {
      this.changeDetectorRef.detach();
    }
    this.removeComboboxClickEvent();
  }

  keyUp() {
    this.focusComboBox();
  }
}
